import { helpers } from 'vuelidate/lib/validators'
import { getIsoDate } from '@/scripts/formatDate'

const checkEmptyData = data => {
  return data === null || data === undefined || (Array.isArray(data) && data?.length === 0)
}

const cyrillic = helpers.regex('cyrillic', /^[ а-яА-ЯёЁ-]*$/)
//const checkDate = helpers.regex('checkDate', /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/)
const checkDate = helpers.regex('checkDate', /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/)
const dateFormat = helpers.regex('dateFormat', /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/)
const snils = helpers.regex('snils', /^\d{3}-\d{3}-\d{3} \d{2}$/)
const setOfSymbols = helpers.regex('setOfSymbols', /^[ а-яА-ЯёЁA-Za-z0-9.,-:;№\_\(\)]*$/)
const cellularPhone = helpers.regex('cellularPhone', /^\+ \[0-9]{16}$/)
const meanScore = helpers.regex('meanScore', /^[3-5]{1}\.[0-9]{3}$/)

const daysRegex = helpers.regex('daysRegex', /^[0-9]$|^[1-9]\d$|^[1-2]\d{2}$|^3[0-5]\d$|^36[0-5]$/)
const hoursRegex = helpers.regex('hoursRegex', /^\d$|^1\d$|^2[0-3]$/)
const secondsMinutesRegex = helpers.regex('secondsMinutesRegex', /^\d$|^[1-5]\d$/)

const regexFrom1To99 = helpers.regex('regexFrom1To99', /^([1-9]|[1-9][0-9])$/)
const regexFrom1To100 = helpers.regex('regexFrom1To100', /^[1-9][0-9]?$|^100$/)
const regexFrom1To9999 = helpers.regex('regexFrom1To9999', /^(?:[1-9][0-9]{3}|[1-9][0-9]{2}|[1-9][0-9]|[1-9])$/)
const regexFrom1To99999 = helpers.regex(
  'regexFrom1To99999',
  /^(?:[1-9][0-9]{4}|[1-9][0-9]{3}|[1-9][0-9]{2}|[1-9][0-9]|[1-9])$/
)
const regexFrom1To10M = helpers.regex('regexFrom1To10M', /^([1-9][0-9]{0,6}|10000000)$/)
const regexMech = helpers.regex('regexMech', /^MECH-\d{3,5}$/)
const regexFloat = helpers.regex('regexFloat', /^(0|[1-9]|[1,9]\d{1})[.]\d{1,3}$/)

const regexFrom0To100WithDecimal = helpers.regex(
  'regexFrom0To100WithDecimal',
  /^([0-9]|[1-9][0-9])([.][1-9]|[.][0-9][1-9])?$|^100$/
)

const fromDateNames = ['fromDate', 'dateFrom', 'executionFromDate', 'agreementDateFrom']
const compareTwoDates = (toDate, obj) => {
  const fromDate = obj[fromDateNames.find(name => Object.hasOwn(obj, name))]
  return fromDate && checkDate(fromDate) && toDate && checkDate(toDate)
    ? new Date(getIsoDate(fromDate)) <= new Date(getIsoDate(toDate))
    : true
}

const checkPeriodBlockAndToDate = (date, obj) => {
  return obj.blockDate && obj.toDate && checkDate(obj.blockDate) && checkDate(obj.toDate)
    ? new Date(obj.blockDate) <= new Date(obj.toDate)
    : true
}

const checkSnilsSum = snils => {
  let sum = 0
  let checkDigit = 0

  if (snils) {
    snils = snils.replace(/-/g, '')
  } else {
    return true
  }

  for (let i = 0; i < 9; i++) {
    sum += parseInt(snils[i]) * (9 - i)
  }

  if (sum < 100) {
    checkDigit = sum
  } else if (sum > 101) {
    checkDigit = parseInt(sum % 101)
    if (checkDigit === 100) {
      checkDigit = 0
    }
  }

  return checkDigit === parseInt(snils.slice(-2))
}

const egeScore = value => +value === 0 || (+value >= 40 && +value <= 100)
const ebeScore = value => +value === 0 || (+value >= 40 && +value <= 100)

const setValidateMessages = property => {
  const validations = property.$params
  const validationsKeys = Object.keys(validations)

  const errors = []
  if (property?.stopSymbols !== false && !property.$dirty) return errors

  validationsKeys.forEach(key => {
    switch (key) {
      case 'required':
        !property[key] && errors.push('Обязательное поле')
        break
      case 'maxLength':
        !property[key] && errors.push(`Не более ${validations.maxLength?.max} символов`)
        break
      case 'maxValue':
        !property[key] && errors.push(`Значение не более ${validations.maxValue?.max}`)
        break
      case 'dateFormat':
        !property[key] && errors.push('Дата указана некорректно')
        break
      case 'email':
        !property[key] && errors.push('E-mail невалидный')
        break
      case 'cyrillic':
        !property[key] && errors.push('Буквы кириллицы, пробел и дефис')
        break
      case 'stopSymbols':
        !property[key] && errors.push('Запрещённые символы')
        break
      case 'snilsFormat':
      case 'checkSnilsSum':
        !property[key] && errors.push('СНИЛС невалидный')
        break
      case 'checkMinAge':
        !property[key] && errors.push('Минимальный возраст обучения ДПО 18 лет')
        break
      case 'regexFrom0To999':
        !property[key] && errors.push('От 0 до 999')
        break
      case 'regexFrom1To99':
        !property[key] && errors.push('От 1 до 99')
        break
      case 'regexFrom1To9999':
        !property[key] && errors.push('От 1 до 9999')
        break
      case 'regexFrom1To99999':
        !property[key] && errors.push('От 1 до 99999')
        break
      case 'regexMech':
        !property[key] && errors.push('MECH-/от 3 до 5 чисел/')
        break
      case 'regexFrom1To10M':
        !property[key] && errors.push('От 1 до 10M')
        break
      case 'between':
        !property[key] && errors.push(`От ${validations.between.min} до ${validations.between.max}`)
        break
      case 'compareTwoDates':
        !property[key] && errors.push('Некорректный диапазон дат')
        break
      case 'checkPeriodBlockAndToDate':
        !property[key] && errors.push('Дата блокировки должна быть раньше даты окончания')
        break
    }
  })
  return errors
}

export {
  cyrillic,
  checkDate,
  snils,
  setOfSymbols,
  cellularPhone,
  meanScore,
  checkSnilsSum,
  egeScore,
  ebeScore,
  daysRegex,
  hoursRegex,
  secondsMinutesRegex,
  regexFrom1To99,
  regexFrom1To9999,
  regexFrom1To99999,
  regexFrom1To100,
  regexFrom1To10M,
  regexMech,
  regexFloat,
  regexFrom0To100WithDecimal,
  setValidateMessages,
  dateFormat,
  checkEmptyData,
  compareTwoDates,
  checkPeriodBlockAndToDate
}
